import { Component } from '@angular/core';

@Component({
  selector: 'know-the-rules-page',
  styleUrls: ['./know-the-rules.component.scss'],
  templateUrl: './know-the-rules.component.html'
})
export class KnowTheRulesComponent {
  breadcrumbItems = [
    { url: '/', title: 'Início' },
    { url: '/indique', title: 'Indique Allya' },
    { title: 'Conheça as regras' },
  ];
}
